import api from '@/services/api';

import { type AuthUser } from '../types';

const BASE_URL = 'account';

/**
 * @param accessToken bearer to use instead of having the API client read the session again. Server-side
 * that read is another JWE decrypt, and a caller that already holds the session has nothing to gain
 * from it.
 */
export const getUserInfo = async (accessToken?: string) => {
  const config = accessToken == null ? undefined : { headers: { Authorization: `Bearer ${accessToken}` } };
  return await api.get<AuthUser>(`${BASE_URL}/user`, config);
};
